import { TournamentState } from '@ps/poker-games-tile-mappers';

import type { Currency } from '@swf/generated/graphql/poker/MTT/schemas';

import type {
  NormalizedTournamentsResponse,
  TornamentUpdateData,
  Tournament,
  TournamentQueryResponse,
  TournamentRaw,
  TournamentsData,
  TournamentsUpdateResponse
} from '../../types/MTT';
import { TILE_MAPPER_CDN_URL } from '../tileMappers';

import imageUrlMock from './pkr_nl_holdem_micro.jpg';
import imageUrlSquareMock from './pkr_nl_holdem_micro_square.jpg';

const currencyEuro: Currency = 'EUR';

export { imageUrlMock };

export const tournamentRaw: TournamentRaw = {
  __typename: 'Tournament',
  id: 3661062576,
  entrants: 10000,
  legacyStatus: 132611,
  prizePool: 102000,
  prizePoolValue: 102000,
  prizePoolUnit: 2,
  isRestricted: false,
  awardSchema: 2,
  tournFlags2: 28185722882,
  satelliteTarget: 0,
  satelliteTargetNameMTT: '<b>Satellite Target Name</b>',
  reEntryAllowed: 2,
  timedTournType: 0,
  timedTournPlayersPercent: 0,
  tournFlagsServInt: 4735505,
  tournGroup: 0,
  whenStartInt: 1698345000,
  regStartInt: 1698345000,
  regEndInt: 1698351300,
  tournFlags: 71308161,
  fee: 200,
  buyIn: 2000,
  name: '<font color=-x-tourn-step-euro><b>$22 Razz: Limbo,</font> <font color=-x-tourn-guarantee>$1K Gtd</font></b>',
  tournTypeName:
    '<font color=-x-tourn-step-euro><b>$22 Razz | Limbo</font> | <font color=-x-tourn-guarantee>$1K Gtd</font></b>',
  mobileName: '',
  pokerNgGroup: '',
  currency: 'USD',
  seats: 6,
  channels: ['ALL', 'REGULAR'],
  tournSpeed: 'SLOW',
  tournSpeedInt: 1,
  whenStart: '2023-10-26T18:30:00.000Z',
  maxPlayers: 5000,
  minPlayers: 5,
  game: 'BADUGI',
  gameInt: 8,
  structure: 'FIXED_LIMIT',
  structureInt: 1,
  isHiLo: false,
  initStack: 5000,
  avgStack: 5000,
  paidPlaces: 5,
  winner: '',
  winnerAward: 10000,
  timeClosed: '2023-10-26T20:30:00.000Z',
  currentLevel: {
    __typename: 'LobbyDataBetting',
    blindsLevel: 1,
    handType: 2,
    hilo: 1,
    structure: 2,
    stakes: {
      __typename: 'TableStakes',
      antes: [10],
      blinds: [10, 20],
      bringIns: [],
      stakes: []
    }
  }
};

export const tournamentRawCurrencyEUR = {
  ...tournamentRaw,
  id: tournamentRaw.id + 1000,
  currency: currencyEuro
};

export const tournament: Tournament = {
  __typename: 'Tournament',
  id: 3661062576,
  entrants: 10000,
  legacyStatus: 132611,
  prizePool: 102000,
  prizePoolValue: 102000,
  prizePoolUnit: 2,
  isRestricted: false,
  awardSchema: 2,
  tournFlags2: 28185722882,
  satelliteTarget: 0,
  satelliteTargetNameMTT: '<b>Satellite Target Name</b>',
  reEntryAllowed: 2,
  timedTournType: 0,
  timedTournPlayersPercent: 0,
  tournFlagsServInt: 4735505,
  tournGroup: 0,
  whenStartInt: 1698345000,
  regStartInt: 1698345000,
  regEndInt: 1698351300,
  tournFlags: 71308161,
  fee: 200,
  buyIn: 2000,
  name: '<font color=-x-tourn-step-euro><b>$22 Razz: Limbo,</font> <font color=-x-tourn-guarantee>$1K Gtd</font></b>',
  tournTypeName:
    '<font color=-x-tourn-step-euro><b>$22 Razz | Limbo</font> | <font color=-x-tourn-guarantee>$1K Gtd</font></b>',
  mobileName: '',
  pokerNgGroup: '',
  currency: 'USD',
  seats: 6,
  channels: ['ALL', 'REGULAR'],
  tournSpeed: 'SLOW',
  tournSpeedInt: 1,
  whenStart: '2023-10-26T18:30:00.000Z',
  maxPlayers: 5000,
  minPlayers: 5,
  game: 'BADUGI',
  gameInt: 8,
  structure: 'FIXED_LIMIT',
  structureInt: 1,
  isHiLo: false,
  isPlayMoney: false,
  tags: [
    {
      title: 'Limit Razz',
      color: 'blue'
    },
    {
      title: '6-MAX',
      color: 'purple'
    },
    {
      title: 'RE-ENTRY',
      color: 'red'
    }
  ],
  imageUrl: TILE_MAPPER_CDN_URL.razzMicro,
  imageSquareUrl: TILE_MAPPER_CDN_URL.razzMicro,
  fallbackImageUrl: TILE_MAPPER_CDN_URL.razzMicro,
  formattedName: '$22 Razz | Limbo | $1K Gtd',
  formattedSidecarName: '$22 Razz: Limbo, $1K Gtd',
  formattedGame: 'Limit Razz',
  formattedState: TournamentState.COMPLETED,
  formattedBuyIn: '$22',
  formattedPrizePool: '$1,020',
  formattedSatelliteTargetName: 'Satellite Target Name',
  shortPrizePool: '$1.02K',
  initStack: 5000,
  avgStack: 5000,
  paidPlaces: 5,
  winner: '',
  winnerAward: 10000,
  formattedWinnerAward: '$100',
  timeClosed: '2023-10-26T20:30:00.000Z',
  currentLevel: {
    __typename: 'LobbyDataBetting',
    blindsLevel: 1,
    handType: 2,
    hilo: 1,
    structure: 2,
    stakes: {
      __typename: 'TableStakes',
      antes: [10],
      blinds: [10, 20],
      bringIns: [],
      stakes: []
    }
  }
};

export const tournamentCurrencyEUR = {
  ...tournament,
  id: tournament.id + 1000,
  currency: currencyEuro,
  formattedBuyIn: '€22',
  formattedPrizePool: '€1,020',
  formattedWinnerAward: '€100',
  shortPrizePool: '€1.02K'
};

export const tournamentsQueryResponse: TournamentQueryResponse = {
  data: {
    mock: [],
    tournaments: [tournamentRaw]
  }
};

export const tournamentsNormalizedResponse: NormalizedTournamentsResponse = {
  tournamentsCount: 1,
  tournamentsData: { [tournament.id]: tournament },
  tournamentsCurrency: tournament.currency
};

export const tournamentsNormalizedResponseCurrencies: NormalizedTournamentsResponse = {
  tournamentsCount: 2,
  tournamentsData: {
    [tournament.id]: tournament,
    [tournamentCurrencyEUR.id]: tournamentCurrencyEUR
  },
  tournamentsCurrency: 'MULTIPLE'
};

export const completedTournament: Tournament = {
  __typename: 'Tournament',
  id: 3661062300,
  entrants: 10000,
  legacyStatus: 132611,
  prizePool: 102000,
  prizePoolValue: 102000,
  prizePoolUnit: 2,
  isRestricted: false,
  awardSchema: 2,
  tournFlags2: 28185722882,
  satelliteTarget: 0,
  satelliteTargetNameMTT: '',
  reEntryAllowed: 2,
  timedTournType: 0,
  timedTournPlayersPercent: 0,
  tournFlagsServInt: 4735505,
  tournGroup: 0,
  whenStartInt: 1698345000,
  regStartInt: 1698345000,
  regEndInt: 1698351300,
  tournFlags: 71308161,
  fee: 200,
  buyIn: 2000,
  name: '<font color=-x-tourn-step-euro><b>$22 Razz: Limbo,</font> <font color=-x-tourn-guarantee>$1K Gtd</font></b>',
  tournTypeName:
    '<font color=-x-tourn-step-euro><b>$22 Razz | Limbo</font> | <font color=-x-tourn-guarantee>$1K Gtd</font></b>',
  mobileName: '',
  pokerNgGroup: '',
  currency: 'USD',
  seats: 6,
  channels: ['ALL', 'REGULAR'],
  tournSpeed: 'SLOW',
  tournSpeedInt: 1,
  whenStart: '2023-10-26T18:30:00.000Z',
  maxPlayers: 5000,
  minPlayers: 5,
  game: 'BADUGI',
  gameInt: 8,
  structure: 'FIXED_LIMIT',
  structureInt: 1,
  isHiLo: false,
  isPlayMoney: false,
  tags: [
    {
      title: 'Limit Razz',
      color: 'blue'
    },
    {
      title: '6-MAX',
      color: 'purple'
    },
    {
      title: 'RE-ENTRY',
      color: 'red'
    }
  ],
  imageUrl: imageUrlMock,
  imageSquareUrl: imageUrlSquareMock,
  fallbackImageUrl: TILE_MAPPER_CDN_URL.razzMicro,
  formattedName: '$22 Razz | Limbo | $1K Gtd',
  formattedSidecarName: '$22 Razz: Limbo, $1K Gtd',
  formattedGame: 'Limit Razz',
  formattedState: TournamentState.COMPLETED,
  formattedBuyIn: '$22',
  formattedPrizePool: '$1,020',
  formattedSatelliteTargetName: '',
  shortPrizePool: '$1.02K',
  initStack: 5000,
  avgStack: 5000,
  paidPlaces: 5,
  winner: '',
  winnerAward: 10000,
  formattedWinnerAward: '$100',
  timeClosed: '2023-10-26T20:30:00.000Z',
  currentLevel: {
    __typename: 'LobbyDataBetting',
    blindsLevel: 1,
    handType: 2,
    hilo: 1,
    structure: 2,
    stakes: {
      __typename: 'TableStakes',
      antes: [10],
      blinds: [10, 20],
      bringIns: [],
      stakes: []
    }
  }
};

export const announcedTournament: Tournament = {
  __typename: 'Tournament',
  id: 3713269931,
  entrants: 0,
  legacyStatus: 0,
  prizePool: 800000,
  prizePoolValue: 800000,
  prizePoolUnit: 2,
  isRestricted: false,
  awardSchema: 2,
  tournFlags2: 28186001410,
  satelliteTarget: 0,
  satelliteTargetNameMTT: '',
  reEntryAllowed: 2,
  timedTournType: 0,
  timedTournPlayersPercent: 0,
  tournFlagsServInt: 4735505,
  tournGroup: 4,
  whenStartInt: 1707903000,
  regStartInt: 1707816600,
  regEndInt: 1707909300,
  tournFlags: 71308161,
  fee: 120,
  buyIn: 980,
  name: '<font color=-x-tourn-special><b>Bounty Builder $11,</font> <font color=-x-tourn-guarantee>$7K Gtd</font></b>',
  tournTypeName:
    '<font color=-x-tourn-special><b>Bounty Builder $11 </font><font color=#525252>|</font> <font color=-x-tourn-guarantee>$7K Gtd</font></b>',
  mobileName: '',
  pokerNgGroup: 'Bounty Builders',
  currency: 'USD',
  seats: 8,
  channels: ['ALL', 'REGULAR'],
  tournSpeed: 'SLOW',
  tournSpeedInt: 1,
  whenStart: '2024-12-14T09:30:00.000Z',
  maxPlayers: 20000,
  minPlayers: 5,
  game: 'BADUGI',
  gameInt: 2,
  structure: 'FIXED_LIMIT',
  structureInt: 3,
  isHiLo: false,
  isPlayMoney: false,
  tags: [
    {
      title: "NL Hold'em",
      color: 'blue'
    },
    {
      title: '8-MAX',
      color: 'purple'
    },
    {
      title: 'RE-ENTRY',
      color: 'red'
    },
    {
      color: 'red',
      title: 'KO'
    }
  ],
  imageUrl: imageUrlMock,
  imageSquareUrl: imageUrlSquareMock,
  fallbackImageUrl: TILE_MAPPER_CDN_URL.holdemMicro,
  formattedName: 'Bounty Builder $11 | $7K Gtd',
  formattedSidecarName: 'Bounty Builder $11, $7K Gtd',
  formattedGame: "NL Hold'em",
  formattedState: TournamentState.ANNOUNCED,
  formattedBuyIn: '$11',
  formattedPrizePool: '$8,000',
  formattedSatelliteTargetName: '',
  shortPrizePool: '$8K',
  initStack: 5000,
  avgStack: 5000,
  paidPlaces: 5,
  winner: '',
  winnerAward: 10000,
  formattedWinnerAward: '$100',
  timeClosed: '2024-12-14T11:30:00.000Z',
  currentLevel: {
    __typename: 'LobbyDataBetting',
    blindsLevel: 1,
    handType: 2,
    hilo: 1,
    structure: 2,
    stakes: {
      __typename: 'TableStakes',
      antes: [10],
      blinds: [10, 20],
      bringIns: [],
      stakes: []
    }
  }
};

export const registeringTournament: Tournament = {
  __typename: 'Tournament',
  id: 3713279631,
  entrants: 0,
  legacyStatus: 384,
  prizePool: 1560000,
  prizePoolValue: 1560000,
  prizePoolUnit: 2,
  isRestricted: false,
  awardSchema: 7,
  tournFlags2: 2147500288,
  satelliteTarget: 3713275649,
  satelliteTargetNameMTT: '',
  reEntryAllowed: 0,
  timedTournType: 1,
  timedTournPlayersPercent: 0,
  tournFlagsServInt: 4735504,
  tournGroup: 0,
  whenStartInt: 1707766200,
  regStartInt: 1707766200,
  regEndInt: 1707768900,
  tournFlags: 71308161,
  fee: 900,
  buyIn: 10000,
  name: '<font color=-x-tourn-step-euro>Titans Event: $109 NLHE, Turbo [Phase 1 Sat]</font>',
  tournTypeName:
    '<font color=-x-tourn-step-euro>Titans Event | $109 NLHE | Turbo [Phase 1 Sat]</font>',
  mobileName: 'Titans Event Sat: $109 [Phase 1]',
  pokerNgGroup: '',
  currency: 'USD',
  seats: 8,
  channels: ['ALL', 'REGULAR'],
  tournSpeed: 'SLOW',
  tournSpeedInt: 2,
  whenStart: '2024-02-12T19:30:00.000Z',
  maxPlayers: 500,
  minPlayers: 4,
  game: 'BADUGI',
  gameInt: 2,
  structure: 'FIXED_LIMIT',
  structureInt: 3,
  isHiLo: false,
  isPlayMoney: false,
  tags: [
    {
      title: "NL Hold'em",
      color: 'blue'
    },
    {
      title: '8-MAX',
      color: 'purple'
    },
    {
      title: 'Turbo',
      color: 'light-grey'
    },
    {
      color: 'red',
      title: 'PHASE'
    },
    {
      title: 'TIME',
      color: 'red'
    },
    {
      title: 'SAT',
      color: 'blue'
    }
  ],
  imageUrl: imageUrlMock,
  imageSquareUrl: imageUrlSquareMock,
  fallbackImageUrl: TILE_MAPPER_CDN_URL.holdemMicro,
  formattedName: 'Titans Event | $109 NLHE | Turbo [Phase 1 Sat]',
  formattedSidecarName: 'Titans Event: $109 NLHE, Turbo [Phase 1 Sat]',
  formattedGame: "NL Hold'em",
  formattedState: TournamentState.REGISTERING,
  formattedBuyIn: '$109',
  formattedPrizePool: '$15,600',
  formattedSatelliteTargetName: '',
  shortPrizePool: '$15.6K',
  initStack: 5000,
  avgStack: 5000,
  paidPlaces: 5,
  winner: '',
  winnerAward: 10000,
  formattedWinnerAward: '$100',
  timeClosed: '2024-02-12T21:30:00.000Z',
  currentLevel: {
    __typename: 'LobbyDataBetting',
    blindsLevel: 1,
    handType: 2,
    hilo: 1,
    structure: 2,
    stakes: {
      __typename: 'TableStakes',
      antes: [10],
      blinds: [10, 20],
      bringIns: [],
      stakes: []
    }
  }
};

export const lateRegistrationTournament: Tournament = {
  __typename: 'Tournament',
  id: 3713269951,
  entrants: 690,
  legacyStatus: 1154,
  prizePool: 1378000,
  prizePoolValue: 1378000,
  prizePoolUnit: 2,
  isRestricted: false,
  awardSchema: 2,
  tournFlags2: 28186001410,
  satelliteTarget: 0,
  satelliteTargetNameMTT: '',
  reEntryAllowed: 2,
  timedTournType: 0,
  timedTournPlayersPercent: 0,
  tournFlagsServInt: 4735505,
  tournGroup: 4,
  whenStartInt: 1707741000,
  regStartInt: 1707741000,
  regEndInt: 1707747300,
  tournFlags: 71308161,
  fee: 200,
  buyIn: 2000,
  name: '<font color=-x-tourn-special><b>Bounty Builder $22,</font> <font color=-x-tourn-guarantee>$10K Gtd</font></b>',
  tournTypeName:
    '<font color=-x-tourn-special><b>Bounty Builder $22 </font><font color=#525252>|</font> <font color=-x-tourn-guarantee>$10K Gtd</font></b>',
  mobileName: '',
  pokerNgGroup: 'Bounty Builders',
  currency: 'USD',
  seats: 8,
  channels: ['ALL', 'REGULAR'],
  tournSpeed: 'SLOW',
  tournSpeedInt: 1,
  whenStart: '2024-02-12T12:30:00.000Z',
  maxPlayers: 20000,
  minPlayers: 5,
  game: 'BADUGI',
  gameInt: 2,
  structure: 'FIXED_LIMIT',
  structureInt: 3,
  isHiLo: false,
  isPlayMoney: false,
  tags: [
    {
      title: "NL Hold'em",
      color: 'blue'
    },
    {
      title: '8-MAX',
      color: 'purple'
    },
    {
      title: 'RE-ENTRY',
      color: 'red'
    },
    {
      color: 'red',
      title: 'KO'
    }
  ],
  imageUrl: imageUrlMock,
  imageSquareUrl: imageUrlSquareMock,
  fallbackImageUrl: TILE_MAPPER_CDN_URL.holdemMicro,
  formattedName: 'Bounty Builder $22 | $10K Gtd',
  formattedSidecarName: 'Bounty Builder $22, $10K Gtd',
  formattedGame: "NL Hold'em",
  formattedState: TournamentState.LATE_REGISTRATION,
  formattedBuyIn: '$22',
  formattedPrizePool: '$13,780',
  formattedSatelliteTargetName: '',
  shortPrizePool: '$13.78K',
  initStack: 5000,
  avgStack: 5000,
  paidPlaces: 5,
  winner: '',
  winnerAward: 10000,
  formattedWinnerAward: '$100',
  timeClosed: '2024-02-12T14:30:00.000Z',
  currentLevel: {
    __typename: 'LobbyDataBetting',
    blindsLevel: 1,
    handType: 2,
    hilo: 1,
    structure: 2,
    stakes: {
      __typename: 'TableStakes',
      antes: [10],
      blinds: [10, 20],
      bringIns: [],
      stakes: []
    }
  }
};

export const runningTournament: Tournament = {
  __typename: 'Tournament',
  id: 3713269928,
  entrants: 942,
  legacyStatus: 132610,
  prizePool: 923160,
  prizePoolValue: 923160,
  prizePoolUnit: 2,
  isRestricted: false,
  awardSchema: 2,
  tournFlags2: 28186001410,
  satelliteTarget: 0,
  satelliteTargetNameMTT: '',
  reEntryAllowed: 2,
  timedTournType: 0,
  timedTournPlayersPercent: 0,
  tournFlagsServInt: 4735505,
  tournGroup: 4,
  whenStartInt: 1707730200,
  regStartInt: 1707730200,
  regEndInt: 1707736500,
  tournFlags: 71308161,
  fee: 120,
  buyIn: 980,
  name: '<font color=-x-tourn-special><b>Bounty Builder $11,</font> <font color=-x-tourn-guarantee>$7K Gtd</font></b>',
  tournTypeName:
    '<font color=-x-tourn-special><b>Bounty Builder $11 </font><font color=#525252>|</font> <font color=-x-tourn-guarantee>$7K Gtd</font></b>',
  mobileName: '',
  pokerNgGroup: 'Bounty Builders',
  currency: 'USD',
  seats: 8,
  channels: ['ALL', 'REGULAR'],
  tournSpeed: 'SLOW',
  tournSpeedInt: 1,
  whenStart: '2024-02-12T09:30:00.000Z',
  maxPlayers: 20000,
  minPlayers: 5,
  game: 'BADUGI',
  gameInt: 2,
  structure: 'FIXED_LIMIT',
  structureInt: 3,
  isHiLo: false,
  isPlayMoney: false,
  tags: [
    {
      title: "NL Hold'em",
      color: 'blue'
    },
    {
      title: '8-MAX',
      color: 'purple'
    },
    {
      title: 'RE-ENTRY',
      color: 'red'
    },
    {
      color: 'red',
      title: 'KO'
    }
  ],
  imageUrl: imageUrlMock,
  imageSquareUrl: imageUrlSquareMock,
  fallbackImageUrl: TILE_MAPPER_CDN_URL.holdemMicro,
  formattedName: 'Bounty Builder $11 | $7K Gtd',
  formattedSidecarName: 'Bounty Builder $11, $7K Gtd',
  formattedGame: "NL Hold'em",
  formattedState: TournamentState.RUNNING,
  formattedBuyIn: '$11',
  formattedPrizePool: '$9,231.60',
  formattedSatelliteTargetName: '',
  shortPrizePool: '$9.23K',
  initStack: 5000,
  avgStack: 5000,
  paidPlaces: 5,
  winner: '',
  winnerAward: 10000,
  formattedWinnerAward: '$100',
  timeClosed: '2024-02-12T11:30:00.000Z',
  currentLevel: {
    __typename: 'LobbyDataBetting',
    blindsLevel: 1,
    handType: 2,
    hilo: 1,
    structure: 2,
    stakes: {
      __typename: 'TableStakes',
      antes: [10],
      blinds: [10, 20],
      bringIns: [],
      stakes: []
    }
  }
};

export const cancelledTournament: Tournament = {
  __typename: 'Tournament',
  id: 3704781528,
  entrants: 34,
  legacyStatus: 1542,
  prizePool: 3400000,
  prizePoolValue: 3400000,
  prizePoolUnit: 2,
  isRestricted: false,
  awardSchema: 2,
  tournFlags2: 28185739266,
  satelliteTarget: 0,
  satelliteTargetNameMTT: '',
  reEntryAllowed: 3,
  timedTournType: 0,
  timedTournPlayersPercent: 0,
  tournFlagsServInt: 4735505,
  tournGroup: 142,
  whenStartInt: 1706635800,
  regStartInt: 1706635800,
  regEndInt: 1706653800,
  tournFlags: 71332737,
  fee: 5000,
  buyIn: 100000,
  name: '<b><font color=-x-tourn-championship>Carnival Series 16-H: $1,050 NLHE [8-Max, Super Tuesday High Roller]</font></b>, <font color=-x-tourn-guarantee><b>$175K Gtd</b></font>',
  tournTypeName:
    '<b><font color=-x-tourn-championship>Carnival Series 16-H: $1,050 NLHE [8-Max, Super Tuesday High Roller]</font></b>, <font color=-x-tourn-guarantee><b>$175K Gtd</b></font>',
  mobileName: 'Event 16-H Super Tuesday High Roller',
  pokerNgGroup: 'Promo6',
  currency: 'USD',
  seats: 8,
  channels: ['ALL', 'REGULAR'],
  tournSpeed: 'SLOW',
  tournSpeedInt: 1,
  whenStart: '2024-01-30T17:30:00.000Z',
  maxPlayers: 10000,
  minPlayers: 5,
  game: 'BADUGI',
  gameInt: 2,
  structure: 'FIXED_LIMIT',
  structureInt: 3,
  isHiLo: false,
  isPlayMoney: false,
  tags: [
    {
      title: "NL Hold'em",
      color: 'blue'
    },
    {
      title: '8-MAX',
      color: 'purple'
    },
    {
      title: 'RE-ENTRY',
      color: 'red'
    }
  ],
  imageUrl: imageUrlMock,
  imageSquareUrl: imageUrlSquareMock,
  fallbackImageUrl: TILE_MAPPER_CDN_URL.holdemMedium,
  formattedName: 'Carnival Series 16-H: $1,050 NLHE [8-Max, Super Tuesday High Roller], $175K Gtd',
  formattedSidecarName:
    'Carnival Series 16-H: $1,050 NLHE [8-Max, Super Tuesday High Roller], $175K Gtd',
  formattedGame: "NL Hold'em",
  formattedState: TournamentState.CANCELLED,
  formattedBuyIn: '$1,050',
  formattedPrizePool: '$34,000',
  formattedSatelliteTargetName: '',
  shortPrizePool: '$34K',
  initStack: 5000,
  avgStack: 5000,
  paidPlaces: 5,
  winner: '',
  winnerAward: 10000,
  formattedWinnerAward: '$100',
  timeClosed: '2024-01-30T19:30:00.000Z',
  currentLevel: {
    __typename: 'LobbyDataBetting',
    blindsLevel: 1,
    handType: 2,
    hilo: 1,
    structure: 2,
    stakes: {
      __typename: 'TableStakes',
      antes: [10],
      blinds: [10, 20],
      bringIns: [],
      stakes: []
    }
  }
};

export const seatingTournament: Tournament = {
  __typename: 'Tournament',
  id: 3713272870,
  entrants: 683,
  legacyStatus: 1153,
  prizePool: 5,
  prizePoolValue: 5,
  prizePoolUnit: 4,
  isRestricted: false,
  awardSchema: 1,
  tournFlags2: 2155888642,
  satelliteTarget: 3713272151,
  satelliteTargetNameMTT: '',
  reEntryAllowed: 0,
  timedTournType: 0,
  timedTournPlayersPercent: 0,
  tournFlagsServInt: 4735497,
  tournGroup: 25,
  whenStartInt: 1707747900,
  regStartInt: 1707747900,
  regEndInt: 1707748800,
  tournFlags: 72227712,
  fee: 0,
  buyIn: 0,
  name: '<font color=-x-tourn-satellite>Sunday Million Sat: $0.11 NLHE [Hyper-Turbo, Freebuy],</font> <font color=-x-tourn-guarantee>50 Seats Gtd</font><font color=-x-tourn-satellite> to </font><font color=Magenta>Mega </font><font color=-x-tourn-satellite>$11 Sat</font>',
  tournTypeName:
    '<font color=-x-tourn-satellite>Sunday Million Sat: $0.11 NLHE [Hyper-Turbo, Freebuy],</font> <font color=-x-tourn-guarantee>50 Seats Gtd</font><font color=-x-tourn-satellite> to </font><font color=Magenta>Mega </font><font color=-x-tourn-satellite>$11 Sat</font>',
  mobileName: 'Round 1 Satellite to the $11 Target',
  pokerNgGroup: 'Sunday Million',
  currency: 'USD',
  seats: 8,
  channels: ['ALL', 'REGULAR'],
  tournSpeed: 'SLOW',
  tournSpeedInt: 3,
  whenStart: '2024-02-12T14:25:00.000Z',
  maxPlayers: 10000,
  minPlayers: 52,
  game: 'BADUGI',
  gameInt: 2,
  structure: 'FIXED_LIMIT',
  structureInt: 3,
  isHiLo: false,
  isPlayMoney: false,
  tags: [
    {
      title: "NL Hold'em",
      color: 'blue'
    },
    {
      title: '8-MAX',
      color: 'purple'
    },
    {
      title: 'Hyper',
      color: 'light-grey'
    },
    {
      color: 'red',
      title: 'REBUY'
    },
    {
      title: 'SAT',
      color: 'blue'
    }
  ],
  imageUrl: imageUrlMock,
  imageSquareUrl: imageUrlSquareMock,
  fallbackImageUrl: TILE_MAPPER_CDN_URL.holdemMicro,
  formattedName:
    'Sunday Million Sat: $0.11 NLHE [Hyper-Turbo, Freebuy], 50 Seats Gtd to Mega $11 Sat',
  formattedSidecarName:
    'Sunday Million Sat: $0.11 NLHE [Hyper-Turbo, Freebuy], 50 Seats Gtd to Mega $11 Sat',
  formattedGame: "NL Hold'em",
  formattedState: TournamentState.SEATING,
  formattedBuyIn: 'Freeroll',
  formattedPrizePool: '5 seats',
  formattedSatelliteTargetName: '',
  shortPrizePool: '5 seats',
  initStack: 5000,
  avgStack: 5000,
  paidPlaces: 5,
  winner: '',
  winnerAward: 1,
  formattedWinnerAward: '1 seat',
  timeClosed: '2024-02-12T16:25:00.000Z',
  currentLevel: {
    __typename: 'LobbyDataBetting',
    blindsLevel: 1,
    handType: 2,
    hilo: 1,
    structure: 2,
    stakes: {
      __typename: 'TableStakes',
      antes: [10],
      blinds: [10, 20],
      bringIns: [],
      stakes: []
    }
  }
};

export const tournamentsData: TournamentsData = {
  [announcedTournament.id]: announcedTournament,
  [cancelledTournament.id]: cancelledTournament,
  [completedTournament.id]: completedTournament,
  [lateRegistrationTournament.id]: lateRegistrationTournament,
  [registeringTournament.id]: registeringTournament,
  [runningTournament.id]: runningTournament,
  [seatingTournament.id]: seatingTournament
};

const tournamentsUpdateInitial: TornamentUpdateData = [
  {
    ...tournamentRaw,
    __typename: 'Initial'
  }
];

export const tournamentUpdate = {
  id: lateRegistrationTournament.id,
  entrants: lateRegistrationTournament.entrants + 55,
  prizePool: lateRegistrationTournament.prizePool + 1000,
  prizePoolValue: lateRegistrationTournament.prizePoolValue + 1000,
  prizePoolUnit: lateRegistrationTournament.prizePoolUnit + 1000,
  legacyStatus: runningTournament.legacyStatus,
  initStack: runningTournament.initStack,
  avgStack: runningTournament.avgStack,
  paidPlaces: runningTournament.paidPlaces,
  winner: runningTournament.winner,
  winnerAward: runningTournament.winnerAward,
  timeClosed: runningTournament.timeClosed,
  currentLevel: {
    __typename: runningTournament.currentLevel['__typename'],
    blindsLevel: runningTournament.currentLevel.blindsLevel + 1,
    handType: runningTournament.currentLevel.handType,
    hilo: runningTournament.currentLevel.hilo,
    structure: runningTournament.currentLevel.structure,
    stakes: {
      __typename: runningTournament.currentLevel.stakes['__typename'],
      antes: runningTournament.currentLevel.stakes.antes,
      blinds: runningTournament.currentLevel.stakes.blinds,
      bringIns: [],
      stakes: []
    }
  }
};

export const tournamentsUpdateResponseInitial: TournamentsUpdateResponse = {
  data: { data: { crud: tournamentsUpdateInitial, crudm: [] } }
};

export const tournamentsUpdateResponse: TournamentsUpdateResponse = {
  data: {
    data: {
      crud: [
        {
          __typename: 'Update',
          id: 1000000000,
          entrants: 100,
          legacyStatus: 100,
          prizePool: 100,
          prizePoolValue: 100,
          prizePoolUnit: 100,
          initStack: 5000,
          avgStack: 5000,
          paidPlaces: 5,
          winner: '',
          winnerAward: 1,
          timeClosed: '2024-02-12T16:25:00.000Z',
          currentLevel: {
            __typename: 'LobbyDataBetting',
            blindsLevel: 1,
            handType: 2,
            hilo: 1,
            structure: 2,
            stakes: {
              __typename: 'TableStakes',
              antes: [10],
              blinds: [10, 20],
              bringIns: [],
              stakes: []
            }
          }
        },
        {
          ...tournamentRaw,
          __typename: 'Create'
        },
        {
          __typename: 'Delete',
          id: cancelledTournament.id
        },
        {
          ...tournamentUpdate,
          __typename: 'Update'
        },
        {
          __typename: 'Delete',
          id: completedTournament.id
        }
      ],
      crudm: []
    }
  }
};
